import React, { useState, useContext } from 'react';
import moment from 'moment';
import * as routes from '../constants/routes';
import Events from './Events.jsx';
import { Col } from 'react-bootstrap'
import { SvgAddPrimaryBrand, SvgChevronDownPrimary } from '../assets/icons';
import MixpanelContext from 'react-mixpanel';

const availabilityNote = ({ nextEvent, nextAvailableAt }) => {
  if(nextEvent === null && nextAvailableAt === null) return 'Available';
  if(nextEvent) return `next meeting ${moment(nextEvent.startAt).fromNow()}`
  return `next available ${moment(nextAvailableAt).fromNow()}`
}

function ScheduleTile(props) {
  const [showAddEvents, setShowAddEvents] = useState(false);
  const mixpanel = useContext(MixpanelContext);

  const schedule = props.schedule
  const descriptionNote = true //todo

  const toggleExpanded = () => {
    if(props.expanded) {
      props.clearExpanded()
    }
    else {
      props.setExpanded()
      mixpanel.track('WFH_Schedule_Expanded')
    }
  }

  return (
    <Col xs={12} lg={6} xl={4} style={{ marginBottom: 28 }}>
      <div style={{textAlign: 'right', fontSize: 13, lineHeight: '28px', color: '#323337' }}>
        { availabilityNote(schedule) }
      </div>
      <div className="schedule tile" style={{ position: 'relative' }}>
        <span className="title">{schedule.title}</span>
        <SvgAddPrimaryBrand onClick={() => props.onAddEntry(schedule)} style={{ cursor: 'pointer', float: 'right'}} />
        <div style={{ lineHeight: '19px', fontSize: 13, color: '#323337', marginBottom: 10 }}>

          { /* This wrapper element must exist in order to preserve the layout of the events. todo: fix */ }
          { descriptionNote && <>
            <div>{ schedule.nextEvent ? <strong>{schedule.nextEvent.title}</strong> : 'No Events Scheduled'}</div>
            { schedule.nextEvent && <div>{schedule.nextEvent.notes}</div> }
            { schedule.nextEvent && <div>{schedule.nextEvent.creator.given_name} at {moment(schedule.nextEvent.startAt).format('LT')}</div> }
          </>}
        </div>
        { props.expanded && <Events schedule={schedule} onEditEntry={props.onEditEntry} /> }
        <SvgChevronDownPrimary
          style={{ transform: (props.expanded ? 'rotate(180deg)' : 'none'), position: 'absolute', bottom: -18, left: 'calc(50% - 18px)', cursor: 'pointer' }}
          onClick={toggleExpanded}
        />
      </div>
    </Col>
  );
}

export default ScheduleTile;
